import { OperatorEnum } from '@y42/json-schema';
import { SelectOption } from '@y42/util/select-option';

export const operationInputDefaultOperatorOptions: Array<SelectOption<OperatorEnum>> = [
  { value: OperatorEnum.Equals, label: 'is equal' },
  { value: OperatorEnum.IsNot, label: 'is not equal' },
  { value: OperatorEnum.In, label: 'is one of' },
  { value: OperatorEnum.NotIn, label: 'is none of' },
  { value: OperatorEnum.StartsWith, label: 'starts with' },
  { value: OperatorEnum.EndsWith, label: 'ends with' },
  { value: OperatorEnum.Contains, label: 'contains' },
  { value: OperatorEnum.NotContains, label: 'not contains' },
  { value: OperatorEnum.IsEmpty, label: 'is empty' },
  { value: OperatorEnum.IsNotEmpty, label: 'is not empty' },
];
